<template>
  <main>
    <section id="parallax" class="section--full section--banner" @mousemove="parallax">
      <video autoplay muted playsinline loop class="section__video">
        <source src="@/assets/video/rctiplus.mp4" type="video/mp4">
      </video>
    </section>
    <section class="container container--short">
      <div class="container--white">
        <h2 class="heading-detail">RCTI+ Special Programs</h2>
        <div class="details">
          <p class="description">
            Dalam rangka menyambut HUT MNC Group yang ke 32, RCTI+ membuat empat program unggulan, beberapa diantaranya merupakan program reguler iconic dari RCTI+. 
          </p>
          <br>
          <p class="description">
            Program unggulan yang akan tayang adalah, pertama, Musik Buat Elo Special HUT MNC Group, kedua, program special Parade Stand Up Comedy Celebrate A Brighter Future, ketiga, Dai Muda Special HUT MNC Group, dan keempat, The Famous: Career, Family and Dream serta The Magnificent Three.
          </p>
        </div>

        <div class="details">
          <img class="md-image" src="@/assets/images/Landscape Efest - Revisi.jpg" alt="">
        </div>

        <div class="details">
          <div class="font-title">Rangkaian Program</div>
          <br>
          <p class="description">
           Berikut on air program unggulan RCTI+ untuk HUT 32 MNC Group adalah sebagai berikut: 
          </p>
          <br>
          <ul class="mg-left-35">
            <li class="description list-block">Musik Buat Elo Special HUT MNC Group, on air tanggal 1 November 2021 pukul 19.00 – 21.00</li>
            <li class="description list-block">Parade Stand Up Comedy Celebrate A Brighter Future, on air tanggal 4 November 2021 pukul 19.00 – 20.00</li>
            <li class="description list-block">Dai Muda Special HUT MNC Group, on air tanggal 6 November 2021 pukul 16.00 – 17.00</li>
            <li class="description list-block">The Famous Episode Ibu Angela Herliani Tanoesoedibjo "Career, Family, and Dreams", on air tanggal 7 November 2021, VOD released pukul 00.00</li>
            <li class="description list-block">The Famous Episode Ibu Valencia Tanoesoedibjo, Ibu Jessica Tanoesoedibjo, dan Ibu Clarissa Tanoesoedibjo “The Magnificent Three”, on air tanggal 13 November 2021, VOD released pukul 00.00</li>
          </ul>
          <br>
          <p class="description">
            Untuk informasi lebih lengkapnya, jangan lupa untuk mengunjungi Official Instagram RCTI+ di <a class="link" target="_blank" href="https://www.instagram.com/rctiplusofficial/">@rctiplusofficial</a>, official Facebook RCTI+ di <a class="link" target="_blank" href="https://www.facebook.com/RCTIPlusOfficial">RCTIPlusOfficial</a> ataupun Official Twitter RCTI+ di <a class="link" target="_blank" href="https://twitter.com/RCTIPlus">@RCTIPlus</a> 
          </p>
        </div>

        <!-- <div class="details">
          <div class="font-title">Informasi lengkap Kegiatan</div>
          <br>
          <p class="description">
            Untuk informasi lebih lengkapnya, jangan lupa untuk mengunjungi Official Instagram RCTIPLUS di <a class="link" target="_blank" href=" https://www.instagram.com/rctiplusofficial/">@rctiplusofficial</a>, official Facebook RCTIPLUS di <a class="link" target="_blank" href="https://www.facebook.com/RCTIPlusOfficial">RCTIPlusOfficial</a> ataupun Official Twitter RCTIPLUS di <a class="link" target="_blank" href="https://twitter.com/RCTIPlus">@RCTIPlus</a> 
          </p>
        </div> -->
      </div>
    </section>
  </main>
</template>

<script>
import parallax from '@/commons/parallax.js'

export default {
  name: 'DetailRcti',
  methods: {
    parallax(e) {
      const elem = document.querySelector("#parallax > video")

      elem.style.top = parallax.parallaxAnimation(e).vidY;
      elem.style.left = parallax.parallaxAnimation(e).vidX;
    
    }
  }
}
</script>